import {
  Box,
  Grid,
  Switch,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade05,
  blackShade07,
  blueColor04,
  borderTextbox,
  displaySwitchGreenColor,
  displaySwitchRedColor,
  greyColor24,
  greyColor40,
  greyColor6,
  logoImgborder1,
  redColor01,
  whiteColor,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import ONDCCatMultiSelect from "../ONDCCatMultiSelect";
import SelectWithLabel from "../../../components/Input/SelectWithLabel";
import { SHIPMENT_REGION_LIST } from "../../../utils/data";
import FormInputBox from "../../../components/Input/FormInputBox";
import RadiosBtnWithLabel from "../../../components/Input/RadiosBtnWithLabel";
import RadioOptionWithLabel from "../../../components/Radio/RadioOptionWithLabel";
import CheckBoxWithLabel from "../../../components/Input/CheckBoxWithLabel";
import { allowOnlyEnglish } from "../../../utils/helper";
import ShipmentPreferenceMultiSelect from "../ShipmentPreferenceMultiSelect";
import styled from "@emotion/styled";

const ShipmentControlsForm = ({
  data,
  setData,
  ondcCategories,
  additionalONDCList,
  handleOndcInfoChange,
  editOndc,
  lspProviderNames,
}) => {
  const handleShipmentMethodChange = (index, key, value) => {
    let shipmentMethodList = data?.ondc?.shipmentMethods || [];
    const shipmentMethodData = {
      ...shipmentMethodList[index],
      [key]: value,
      error: null,
    };

    shipmentMethodList[index] = shipmentMethodData;
    handleOndcInfoChange("shipmentMethods", shipmentMethodList);
  };

  const handlePreferenceChange = (key, value) => {
    handleOndcInfoChange(key, value);
  };

  return (
    <Box>
      <Typography
        component="h6"
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: blackShade05,
          mt: { md: 2, xs: 1 },
        }}
      >
        Shipments Controls
      </Typography>
      <Box mt={{ md: 1, xs: 0.5 }} borderBottom={logoImgborder1} pb={1.5}>
        <Grid container rowSpacing={{ xs: 0.8, md: 0 }} columnSpacing={3}>
          <Grid item xs={12} md={3}>
            <SelectWithLabel
              label="Shipment Region"
              value={data?.ondc?.ondcSupportRegion?.label}
              onValueChange={(region) => {
                handleOndcInfoChange("ondcSupportRegion", region);
              }}
              returnFullItem
              menuList={SHIPMENT_REGION_LIST}
              errorMsg={data?.errors?.ondcSupportRegion}
            />
          </Grid>

          <Grid item xs={12} md={3.6}>
            <Box mt={{ xs: 1, md: 0 }}>
              <FormInputBox
                label="Shipment Distance (in KM)"
                placeholder=""
                required
                value={data?.ondc?.ondcSupportDistanceKm}
                onChange={({ target }) => {
                  const value = target?.value?.replace(/[^0-9]/g, "");
                  handleOndcInfoChange("ondcSupportDistanceKm", value);
                }}
                error={data?.errors?.ondcSupportDistanceKm}
                helperText="For Hyperlocal delivery choose distance as 5KM"
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={3}></Grid>

          {/* <Grid item xs={12} md={5}>
            <Typography
              component="p"
              fontSize={13}
              fontWeight={400}
              color={greyColor6}
              display="inline"
            >
              Delivery Methods
              <Typography
                variant="body1"
                sx={{ display: "inline", color: "#f00" }}
              >
                *
              </Typography>
            </Typography>

            <Box>
              <CheckBoxWithLabel
                label="Delivery"
                checked={data?.ondc?.ondcBPPFulfillments?.type === "Delivery"}
                onValuesChanged={() => {
                  handleDeliveryMethodChange("F1", "Delivery");
                }}
                labelStyle={styles.radioLabel}
              />

              <CheckBoxWithLabel
                label="Self-Pickup"
                checked={data?.ondc?.ondcBPPFulfillments?.type === "Self-Pickup"}
                onValuesChanged={() => {
                  handleDeliveryMethodChange("F2", "Self-Pickup");
                }}
                labelStyle={styles.radioLabel}
                disabled
              />

            </Box>

            <Typography
              variant="subtitle1"
              component="p"
              fontSize={12}
              sx={{ color: "red" }}
            >
              {data?.errors?.ondcBPPFulfillments}
            </Typography>
          </Grid> */}

          {/* <Grid item xs={12} md={3}>
            <RadioOptionWithLabel
              label="Customer Discount"
              required
              value={
                data?.ondc?.ondcCustomerDiscountEnabled === ""
                  ? ""
                  : data?.ondc?.ondcCustomerDiscountEnabled === "yes"
                  ? "Yes"
                  : "No"
              }
              onYesClick={() => {
                handleOndcInfoChange("ondcCustomerDiscountEnabled", "yes");
              }}
              onNoClick={() => {
                handleOndcInfoChange("ondcCustomerDiscountEnabled", "no");
              }}
              error={data?.errors?.ondcCustomerDiscountEnabled}
            />
          </Grid> */}
        </Grid>
      </Box>

      <Box mt={{ md: 1, xs: 0 }} pb={1.5}>
        <Typography
          component="h6"
          sx={{
            fontSize: { xs: 14, md: 15 },
            fontWeight: 600,
            color: blackShade05,
            mt: { md: 2.5, xs: 2 },
          }}
        >
          Shipment Methods
        </Typography>

        <StyledSwitch
          isChecked={data?.ondc?.isONDCShipmentEnabled}
          color="warning"
          label={data?.ondc?.isONDCShipmentEnabled ? "Enabled" : "Not Enabled"}
          onChange={({ target }) => {
            handleOndcInfoChange("isONDCShipmentEnabled", target?.checked);
            // handleOndcInfoChange("isONDCShipmentEnabled", true);
          }}
        />

        {data?.ondc?.isONDCShipmentEnabled && (
          <>
            <Grid container>
              <Grid item xs={12} md={10}>
                <Box>
                  {data?.ondc?.shipmentMethods?.map((item, index) => {
                    return (
                      <ShipmentMethodInfo
                        key={item?.code}
                        index={index}
                        shipmentMethodName={item?.label}
                        infoText={item?.infoText}
                        isEnabled={item?.isEnabled}
                        fromDistance={item?.min}
                        toDistance={item?.max}
                        maxKm={item?.maxKm}
                        infoTextColor={item?.infoColor}
                        onDataChange={(key, value) => {
                          handleShipmentMethodChange(index, key, value);
                        }}
                        error={item?.error}
                      />
                    );
                  })}
                </Box>
              </Grid>
            </Grid>
            {data?.errors?.shipmentMethods && (
              <Typography
                fontSize={12}
                fontWeight={500}
                color={redColor01}
                mt={1}
              >
                {data?.errors?.shipmentMethods}
              </Typography>
            )}
          </>
        )}
      </Box>

      {data?.ondc?.isONDCShipmentEnabled && (
        <Box mt={{ md: 1, xs: 0.5 }} pb={1.5}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: blackShade05,
              mt: { md: 1.6, xs: 1.5 },
            }}
          >
            Shipping Preferences
          </Typography>

          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 600,
              color: blackShade05,
              lineHeight: "20px",
              mt: { md: 1, xs: 1 },
            }}
          >
            Logistics Partner
          </Typography>

          <Box mt={1}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={4}>
                <ShipmentPreferenceMultiSelect
                  label={`Preferred`}
                  value={data?.ondc?.preferredLsps}
                  onValueChange={(updatedValue) =>
                    handlePreferenceChange("preferredLsps", updatedValue)
                  }
                  menuList={lspProviderNames?.filter(
                    (item) => !data?.ondc?.rejectedLsps?.includes(item)
                  )}
                  //   error={data?.errors?.ondcDomain}
                  //   disabled={editOndc}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <ShipmentPreferenceMultiSelect
                  label={`Non Preferred`}
                  value={data?.ondc?.rejectedLsps}
                  onValueChange={(updatedValue) =>
                    handlePreferenceChange("rejectedLsps", updatedValue)
                  }
                  // menuList={lspProviderNames}
                  menuList={lspProviderNames?.filter(
                    (item) => !data?.ondc?.preferredLsps?.includes(item)
                  )}
                  //   error={data?.errors?.ondcDomain}
                  //   disabled={editOndc}
                />
              </Grid>
            </Grid>
          </Box>

          <Typography
            sx={{
              fontSize: { xs: 12, md: 13 },
              fontWeight: 600,
              color: blueColor04,
              lineHeight: "20px",
              mt: { md: 2, xs: 1.5 },
            }}
          >
            If preferred logistics partner is not available, we will default to
            next best available choice
          </Typography>

          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 400,
              color: greyColor40,
              lineHeight: "20px",
              mt: { md: 2, xs: 1.5 },
            }}
          >
            Shipping Options
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              mt: { xs: 1, md: 0.5 },
            }}
          >
            <RadiosBtnWithLabel
              label="Low Cost"
              checked={true}
              onValuesChanged={() => {}}
              labelStyles={{
                color: blackColor,
                fontSize: 13,
                fontWeight: 500,
              }}
              disabled={false}
            />

            <RadiosBtnWithLabel
              label="Fastest Pickup"
              //   checked={value === "Yes"}
              onValuesChanged={() => {}}
              labelStyles={{
                color: blackColor,
                fontSize: 13,
                fontWeight: 500,
                opacity: 0.5,
              }}
              disabled={true}
            />

            <RadiosBtnWithLabel
              label="Best Delivered SLA"
              //   checked={value === "Yes"}
              onValuesChanged={() => {}}
              labelStyles={{
                color: blackColor,
                fontSize: 13,
                fontWeight: 500,
                opacity: 0.5,
              }}
              disabled={true}
            />
          </Box>

          <Typography
            fontSize={{ xs: 12.5, md: 13.5 }}
            fontWeight={500}
            lineHeight="20px"
            color={blackColor}
            m="8px 0 6px"
          >
            Max % incremental shipping cost allowed <br />
            <Typography
              component="span"
              fontSize={{ xs: 12, md: 13 }}
              fontWeight={400}
              lineHeight="15px"
              color={greyColor40}
            >
              (if shipping price increases by approval time)
            </Typography>
          </Typography>

          <Grid container>
            <Grid item xs={12} md={3}>
              <FormInputBox
                width="300px"
                label=""
                placeholder=""
                value={data?.ondc?.costIncrementalPercentage}
                onChange={({ target }) => {
                  const value = target.value
                  const regex = /^\d{0,7}(\.\d{0,2})?$/;
                  if (regex.test(value) ) {
                    handleOndcInfoChange(
                      "costIncrementalPercentage",
                      value
                    );
                  }
                }}
                // onChange={({ target }) => {
                //   const value = target?.value?.replace(/[^0-9]/g, "");

                //   // Ensure the value is within the range of 0 to 100
                //   const boundedValue = Math.min(Math.max(value, 0), 100);

                //   handleOndcInfoChange(
                //     "costIncrementalPercentage",
                //     boundedValue
                //   );
                // }}
                autoComplete="off"
                error={data?.errors?.costIncrementalPercentage}
              />
            </Grid>
          </Grid>

          <Typography
            fontSize={{ xs: 12, md: 13 }}
            fontWeight={400}
            lineHeight="20px"
            color={greyColor40}
            mt={{ xs: 1, md: -1 }}
          >
            Ex: 50% Original Shipping price - ₹100, Recalculated - upto ₹150
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ShipmentControlsForm;

const ShipmentMethodInfo = ({
  index,
  shipmentMethodName,
  isEnabled,
  onDataChange,
  toDistance,
  fromDistance,
  maxKm,
  infoText,
  error,
  infoTextColor,
}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Box mt={{ xs: index == 0 ? 0 : 1.8, md: 2.3 }}>
      <Grid container rowSpacing={{ xs: 2, md: 0 }}>
        <Grid item xs={8} md={2.4}>
          <Typography
            component="h5"
            fontSize={{ xs: 13, md: 13 }}
            color={blackColor}
            fontWeight={500}
            lineHeight="30px"
            mt={0.4}
          >
            {shipmentMethodName}
          </Typography>

          <Typography
            fontSize={{ xs: 11, md: 12 }}
            fontWeight={500}
            color={infoTextColor || yellowShade03}
            lineHeight="8px"
          >
            {infoText}
          </Typography>
        </Grid>

        <Grid item xs={4} md={1.7}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-end", md: "flex-start" },
              mr: { xs: -3, md: 0 },
            }}
          >
            <StyledSwitch
              isChecked={infoText == '(Coming Soon)' ? false : isEnabled}
              color="warning"
              onChange={({ target }) => {
                if(infoText == '(Coming Soon)') return
                onDataChange("isEnabled", target?.checked);
              }}
            />

            <Typography
              width="50px"
              fontSize={{ xs: 13, md: 13.5 }}
              color={blackShade07}
              fontWeight={500}
              lineHeight="20px"
              ml={{ xs: -0.5, md: 0 }}
            >
              {isEnabled ? "Yes" : "No"}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            // flexDirection={{ xs: "column", md: "row" }}
            alignItems={{ xs: "flex-start", md: "center" }}
            gap={{ xs: 1.5, md: 2.5 }}
          >
            <DistanceInput
              label="From"
              subText={matches ? "" : "(in KM)"}
              value={fromDistance}
              onChange={({ target }) => {
                const value = target?.value?.replace(/[^0-9]/g, "");
                onDataChange("min", value);
              }}
              disabled={!isEnabled}
              maxKm={maxKm}
            />

            <DistanceInput
              label="To"
              subText={matches ? "" : "(in KM)"}
              endText={matches ? "(in KM)" : ""}
              placeholder={`Max ${maxKm} KM`}
              value={toDistance}
              onChange={({ target }) => {
                const value = target?.value?.replace(/[^0-9]/g, "");
                onDataChange("max", value);
              }}
              disabled={!isEnabled}
              maxKm={maxKm}
            />
          </Box>
        </Grid>
      </Grid>

      {error && (
        <Typography fontSize={11} fontWeight={500} color={redColor01} mt={0.6}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

const DistanceInput = ({
  label,
  subText,
  value,
  disabled,
  onChange,
  placeholder,
  endText,
}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const sanitizedValue = allowOnlyEnglish(inputValue);

    if (onChange) {
      onChange({ target: { value: sanitizedValue } });
    }
  };

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      alignItems="flex-start"
      gap={1.3}
    >
      <Typography
        // width={{ xs: "50px", md: "auto" }}
        fontSize={{ xs: 12, md: 13 }}
        fontWeight={500}
        color={blackColor}
        mt={0.8}
        sx={{ opacity: disabled ? 0.7 : 1 }}
      >
        {label}{" "}
        <Typography
          component="span"
          fontSize={11}
          fontWeight={500}
          color={greyColor40}
        >
          {subText}
        </Typography>
      </Typography>

      <Box width={{ xs: "150px", md: "100px" }}>
        <TextField
          variant="standard"
          required={true}
          fullWidth
          disabled={disabled}
          value={value}
          onChange={handleInputChange}
          placeholder={placeholder}
          autoComplete="off"
          sx={{
            fontSize: 13,
            fontWeight: 500,
            color: blackShade05,
            opacity: disabled ? 0.7 : 1,
            borderBottom: borderTextbox,
            // borderRadius: "6px",
            mb: 0.5,
            backgroundColor: whiteColor,
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "#000000",
            },
          }}
          InputProps={{
            style: {
              padding: matches ? "1px 8px 1px 8px" : "2px 8px 2px 8px",
              fontSize: 13,
              fontWeight: 500,
            },
            disableUnderline: true,
          }}
        />
      </Box>

      {endText && (
        <Typography
          fontSize={{ xs: 12, md: 13 }}
          fontWeight={500}
          color={blackColor}
          mt={0.8}
          sx={{ opacity: disabled ? 0.7 : 1 }}
        >
          {endText}
        </Typography>
      )}
    </Box>
  );
};

const StyledSwitch = ({ isChecked, onChange, label, gap, labelColor }) => {
  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    cursor: "none !important",
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(17.5px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: displaySwitchGreenColor,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: displaySwitchGreenColor,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      backgroundColor: "rgba(0,0,0,0.2)",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={gap || "10px"}
      mt={{ xs: 0, md: "4px" }}
    >
      <IOSSwitch sx={{ m: 1 }} checked={isChecked} onChange={onChange} />

      <Typography
        component="body2"
        fontSize={14}
        color={labelColor || greyColor24}
        fontWeight={500}
        lineHeight="20px"
        sx={{ textDecoration: labelColor ? "underline" : "none" }}
      >
        {label}
      </Typography>
    </Box>
  );
};

const styles = {
  sectionHeader: {
    fontSize: { xs: 15, md: 15 },
    color: blackColor,
    fontWeight: 600,
    lineHeight: "20px",
    mb: { md: 2, xs: 1 },
  },

  radioLabel: {
    color: greyColor6,
    fontSize: 13,
    fontWeight: 400,
  },
};
